import { InjectionToken } from '@angular/core';
import { SubmissionState } from '../types';

export const DefaultSubmissionState: SubmissionState = {
  canCloseDialog: false,
  entity_type: "",
  error: null,
  irisRoutingGroupDta: {
    data: [],
    total: 0
  },
  iris_mapping: {
    envelope_type: {
      name: ""
    },
    routing_group: {
      id: 0,
      name: ""
    }
  },
  isLoading: true,
  workspaceTypeId: ""
};

export const DEFAULT_SUBMISSION_STATE = new InjectionToken(
  'Default Submission state',
  {
    factory: () => ({ ...DefaultSubmissionState }),
  },
);
